import React from "react";
import Login from "../components/login";
import ForgotPassword from "../components/forgotPassword";
import MenuCategorysListContainer from "../menuCategoryLower/menuCategoryListContainer";
import {RoutingDefinition} from "digimuth-components/dist/components/crudBreadcrumb/crudBreadcrumb";
import {LoadingOutlined} from "@ant-design/icons";
import {Spin} from "antd";
import styles from "./routingContainer.module.scss";
import DeployContainer from "../deploy/deployContainer";
import {Route, Routes} from "react-router-dom";
import {AuthInitialized, Protected} from "./routingWrappers";
import ForgotPasswordCompletePage from "../authentication/forgotPasswordComplete/forgotPasswordCompletePage";
import ActivatePage from "../authentication/activate/activatePage";
import {useSelector} from "react-redux";
import {getCurrentUser} from "../../redux/applicationUserSlice";
import {ApplicationUserRole} from "../../api";
import OrdersListContainer from "../order/orderListContainer";
import OrderProductsListContainer from "../orderProduct/orderProductListContainer";
import NewsSectionsListContainer from "../newsSection/newsSectionListContainer";
import UserListContainer from "../userList/userListContainer";
import MenuEntryListContainer from "../menuEntryLower/menuEntryListContainer";
import MenuContainer from "../menu/menuContainer";
import AddressesListContainer from "../address/addressListContainer";
import BeersListContainer from "../beerLower/beerListContainer";
import MainPage from "../components/mainPage";
import CategoriesListContainer from "../category/categoryListContainer";
import ProductsListContainer from "../product/productListContainer";
import ProductPricesListContainer from "../productPrice/productPriceListContainer";
import DiscountCodesListContainer from "../discountCode/discountCodeListContainer";
import DiscountCodesFormContainer from "../discountCode/discountCodeForm/discountCodeFormContainer";
import ProductDetailsListContainer from "../productDetail/productDetailListContainer";
import BasketsListContainer from "../basket/basketListContainer";
import BasketProductsListContainer from "../basket/basketProductsListContainer";
import OrderRefundFormAddContainer from "../orderRefund/orderRefundForm/orderRefundFormContainer";
import OrderDetailsContainer from "../order/details/orderDetailsContainer";

const mainPage = {
    route: "/",
    name: "Strona główna"
};

const orders = {
    route: "/orders",
    name: "Zamówienia"
}

const menuCategoryTable = {
    route: "/menuCategoryTable",
    name: "Kategorie menu"
};

const baskets = {
    route: "/baskets",
    name: "Koszyki"
}

const users = {
    route: "/users",
    name: "Użytkownicy"
}

const categoryProducts = {
    route: "/categoryTable",
    name: "Kategorie produktów"
}

const productsByCategoryTable = {
    route: "/category/:categoryId/products",
    name: "Produkty"
};


export const RoutingPaths: { [key: string]: RoutingDefinition } = {
    login: {
        route: "/login"
    },
    activate: {
        route: "/activate"
    },
    forgotPassword: {
        route: "/forgotPassword"
    },
    forgotPasswordComplete: {
        route: "/forgotPasswordComplete"
    },
    menuEntryTable: {
        route: "/menuEntryTable/:menuCategoryId",
        breadcrumbEntries: [mainPage, menuCategoryTable, {name: "Wpisy menu"}]
    },
    menuCategoryTable: {
        ...menuCategoryTable,
        breadcrumbEntries: [mainPage, {name: "Kategorie menu"}]
    },
    orders: {
        ...orders,
        breadcrumbEntries: [mainPage, {name: "Zamówienia"}]
    },
    orderDetails: {
        route: "/order/:orderId",
        breadcrumbEntries: [mainPage, orders, {name: "Szczegóły zamówienia"}]
    },
    baskets: {
        ...baskets,
        breadcrumbEntries: [mainPage, {name: "Koszyki"}]
    },
    basketProducts: {
        route: "/basket/:basketId",
        breadcrumbEntries: [mainPage, baskets, {name: "Szczegóły koszyka"}]
    },
    news: {
        route: "/news",
        breadcrumbEntries: [mainPage, {name: "Aktualności"}]
    },
    beerTable: {
        route: "/beerTable",
        breadcrumbEntries: [mainPage, {name: "Rodzaje piw"}]
    },
    deploy: {
        route: "/deploy",
        breadcrumbEntries: [mainPage, {name: "Publikacja"}]
    },
    menu: {
        route: "/menu",
        breadcrumbEntries: [mainPage, {name: "Menu"}]
    },
    userList: {
        route: "/users",
        breadcrumbEntries: [mainPage, {name: "Użytkownicy"}]
    },
    userAddress: {
        route: "/users/:userId/addresses",
        breadcrumbEntries: [mainPage, users, {name: "Adresy użytkownika"}]
    },
    subcategoryTable: {
        route: "/categoryTable/:categoryId",
        breadcrumbEntries: [mainPage, {name: "Kategorie produktów"}]
    },
    parentCategoryTable: {
        route: "/categoryTable",
        breadcrumbEntries: [mainPage, {name: "Kategorie produktów"}]
    },
    productsByCategoryTable: {
        route: "/category/:categoryId/products",
        breadcrumbEntries: [mainPage, categoryProducts, productsByCategoryTable]
    },
    productsPriceTable: {
        route: "/category/:categoryId/products/:productId/prices",
        breadcrumbEntries: [mainPage, categoryProducts, productsByCategoryTable, {name: "Ceny produktu"}]
    },
    productsDetailsTable: {
        route: "/category/:categoryId/products/:productId/details",
        breadcrumbEntries: [mainPage, categoryProducts, productsByCategoryTable, {name: "Szczegóły produktu"}]
    },
    discountCodeTable: {
        route: "/discountCodeTable",
        breadcrumbEntries: [mainPage, {name: "Koby rabatowe"}]
    },
    discountCodeEdit: {
        route: "/discountCode/:id/edit",
        breadcrumbEntries: [mainPage, {name: "Koby rabatowe"}]
    },
    discountCodeAdd: {
        route: "/discountCode/add",
        breadcrumbEntries: [mainPage, {name: "Koby rabatowe"}]
    },
    orderRefundAdd: {
        route: "/order/refund/add/:guid",
        breadcrumbEntries: [mainPage, orders, {name: "Zwroty"}]
    },
    mainPage
};

const loadingIcon = <LoadingOutlined className={styles.loadingIcon} spin/>;
export const loadingSpin = <Spin className={styles.loadingContainer} indicator={loadingIcon}/>

export default function RoutingContainer() {
    const user = useSelector(getCurrentUser);

    return <Routes>
        <Route path={RoutingPaths.login.route} element={
            <AuthInitialized>
                <Login/>
            </AuthInitialized>
        }/>
        <Route path={RoutingPaths.forgotPassword.route} element={
            <AuthInitialized>
                <ForgotPassword/>
            </AuthInitialized>
        }/>
        <Route path={RoutingPaths.forgotPasswordComplete.route} element={
            <AuthInitialized>
                <ForgotPasswordCompletePage/>
            </AuthInitialized>
        }/>
        <Route path={RoutingPaths.activate.route} element={
            <AuthInitialized>
                <ActivatePage/>
            </AuthInitialized>
        }/>
        <Route path={RoutingPaths.deploy.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <DeployContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.menuCategoryTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.MenuManager]}>
                <MenuCategorysListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.orders.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.OrderManager]}>
                <OrdersListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.orderDetails.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.OrderManager]}>
                <OrderDetailsContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.baskets.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.OrderManager]}>
                <BasketsListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.basketProducts.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.OrderManager]}>
                <BasketProductsListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.menu.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.MenuManager]}>
                <MenuContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.menuEntryTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.MenuManager]}>
                <MenuEntryListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.news.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.NewsManager]}>
                <NewsSectionsListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.beerTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.BeerManager]}>
                <BeersListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.mainPage.route} element={
            <Protected>
                <MainPage/>
            </Protected>
        }/>
        <Route path={RoutingPaths.userList.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <UserListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.userAddress.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <AddressesListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.parentCategoryTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <CategoriesListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.subcategoryTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <CategoriesListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.productsByCategoryTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin || ApplicationUserRole.ProductManager]}>
                <ProductsListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.productsPriceTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin || ApplicationUserRole.ProductManager]}>
                <ProductPricesListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.productsDetailsTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin || ApplicationUserRole.ProductManager]}>
                <ProductDetailsListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.discountCodeTable.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <DiscountCodesListContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.discountCodeEdit.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <DiscountCodesFormContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.discountCodeAdd.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin]}>
                <DiscountCodesFormContainer/>
            </Protected>
        }/>
        <Route path={RoutingPaths.orderRefundAdd.route} element={
            <Protected allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.OrderManager]}>
                <OrderRefundFormAddContainer/>
            </Protected>
        }/>
    </Routes>
}



